// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3bAgJ","select":"Header_select__JYI11","clinic":"Header_clinic__1ajx1"};